<template>
  <el-dialog class="dialog-edit-is-win" :title="title" :visible.sync="visible" width="380px">
    <ConfigForms ref="form" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';

const formItems = [
  { type: 'text', label: '名称', required: true, key: 'name' },
  { type: 'number', label: '达成目标', required: true, key: 'finishCount' },
  { type: 'number', label: '收益率', required: true, key: 'incomeRate' },
  { type: 'number', label: '排序值', required: false, key: 'sort' },
]
export default {
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑配置' : '新增配置'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = row
      this.visible = true
    },
    async sure() {
      try {
        const data = await this.$refs.form.validate();
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {

      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-is-win {

}
</style>
